import { ModelBase } from 'store/model-base';

export class CmsNowMoreOptions extends ModelBase {
    public static storeName: string = 'cmsNowMoreOptions';

    public header: string;
    public content: string[];
    public primaryButton: string;
    public secondaryButton?: string;
    public secondaryUiSref?: string;
    public options?: NowMoreOption[];
    public portOut: CmsNowPortOutTransferDetails;
}
